export enum ShareModalTypes {
  COACH = "Coach",
  TEAM = "Team",
  ASSESSMENT = "Assessment",
  WORKOUT = "Workout",
  BLOG = "Blog",
}

export interface ITexts {
  componentTitle: string;
  messageTitle: string;
  messageDescription: string;
  componentDescription: string;
}
